import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ModalComponentBaseProps } from '@pcmp/react-providers';

import Button from '@ingka/button';
import { Prompt, ModalHeader, ModalFooter } from '@ingka/modal';

type PromptModalProps = ModalComponentBaseProps & {
  confirm: () => void;
};

const CommunicationCarrierPrompt: FC<PromptModalProps> = ({
  handleDismiss,
  confirm,
  ...rest
}) => {
  const { t } = useTranslation();
  const handleConfirm = () => {
    handleDismiss();
    confirm();
  };

  return (
    <Prompt
      {...rest}
      data-testid="prompt-communication-carrier"
      footer={
        <ModalFooter>
          <Button
            data-testid="prompt-cancel"
            text={t('label.goBack')}
            type="secondary"
            onClick={handleDismiss}
          />
          <Button
            data-testid="prompt-confirm"
            text={t('label.accept')}
            type="primary"
            onClick={handleConfirm}
          />
        </ModalFooter>
      }
      header={<ModalHeader ariaCloseTxt="Close button text" />}
      title={t(`page.codes.communicationCarrierPrompt.title`)}
      titleId="communication-carrier-prompt"
    >
      <p>{t('page.codes.communicationCarrierPrompt.description')}</p>
    </Prompt>
  );
};

export default CommunicationCarrierPrompt;
